"use strict";
var __importStar =
  (this && this.__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const canvas_txt_1 = __importDefault(require("canvas-txt"));
class CanvasTxt extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef() || props.externalCanvasRef;
  }
  componentDidMount() {
    const ctx = this.ref.current.getContext("2d");
    const {
      debug,
      align,
      vAlign,
      fontSize,
      font,
      lineHeight,
      x,
      y,
      width,
      height,
    } = this.props.drawTxtProps || {};
    canvas_txt_1.default.debug = debug;
    canvas_txt_1.default.align = align;
    canvas_txt_1.default.vAlign = vAlign;
    canvas_txt_1.default.fontSize = fontSize;
    canvas_txt_1.default.font = font;
    canvas_txt_1.default.lineHeight = lineHeight;
    canvas_txt_1.default.drawText(ctx, this.props.text, x, y, width, height);
  }
  render() {
    console.log(this.props);
    const { externalCanvasRef, height, width } = this.props;
    if (externalCanvasRef) {
      return null;
    }
    return React.createElement("canvas", {
      ref: this.ref,
      height: height,
      width: width,
    });
  }
}
exports.default = CanvasTxt;
//# sourceMappingURL=CanvasTxt.js.map
